import styled from "styled-components";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Accordion from "@mui/material/Accordion";

export const StyledTypography = styled(Typography)`
  display: flex;
  align-items: center;
  @media (max-width: 900px) {
    font-size: 13px !important;
    margin-top: 4px;
    margin-bottom: 4px;
  }
  color: gray;
`;

export const StyledTypographyText = styled(Typography)`
  direction: rtl;
  text-align: justify;
  padding-top: 5px;
  line-height: 31px;
  word-wrap:anywhere;
`;

export const StyledTypographyDiv = styled.div`
  width: 100%;
  display: flex;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;
export const StyledIconButton = styled(IconButton)`
  border-radius: 100% !important;
  width: 40px !important;
  height: 40px !important;
  margin: 10px !important;
  box-shadow: 0px 0px 9px -6px black;
  margin-top:12px !important;
`;

export const StyledMainDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  background: white;
  margin-bottom:4px;
  margin-top:4px;
`;
export const StyledAccordion = styled(Accordion)`
  width: 100%;
  box-shadow: none !important;
`;

export const DeleteIconWrapper = styled.div`
  height: 100%;
  position:relative;
`;
